export const SET_CATEGORY_DATA = "SET_CATEGORY_DATA",
             RIGHTBAR_OPEN = "RIGHTBAR_OPEN",
             RIGHTBAR_CLOSE = "RIGHTBAR_CLOSE",
             CURRENT_PATH = "CURRENT_PATH",
             SEARCH_RESULT = "SEARCH_RESULT",
             SEARCH_DATA = "SEARCH_DATA",
             SEARCH_STATE = "SEARCH_STATE",
             SET_ALL_CATEGORY = "SET_ALL_CATEGORY",
             PENDING_COUNT = "PENDING_COUNT",
             SEARCH_TRIGGER = "SEARCH_TRIGGER",
             NOTIFY_COUNT = "NOTIFY_COUNT",
             ARCHIVE_TRIGGER = "ARCHIVE_TRIGGER"